import TeamChecks from '../components/Check/TeamChecks'

let routes = {
    path: '/teamChecks',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/teamChecks',
            name: 'Pontos da equipe',
            component: TeamChecks
        }
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/teamChecks.js